import { render, staticRenderFns } from "./Stopped.vue?vue&type=template&id=2d193fb2&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d193fb2')) {
      api.createRecord('2d193fb2', component.options)
    } else {
      api.reload('2d193fb2', component.options)
    }
    module.hot.accept("./Stopped.vue?vue&type=template&id=2d193fb2&", function () {
      api.rerender('2d193fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/serviceStatus/Stopped.vue"
export default component.exports